import React from 'react';

import { Grid } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { LumaTheme } from 'embeds/core/styles/getTheme';
import { get } from 'lodash';

import { Chip } from 'components/v2';

import { useFiltersContext } from '../context/FixedFiltersContext';

const styles = ({ spacing: { unit } }: LumaTheme) =>
  createStyles({
    contentWrapper: {
      padding: `${unit * 2}px ${unit * 3}px`,
      minHeight: 50,
      maxHeight: 150,
      overflow: 'auto',
    },
    readOnly: {
      pointerEvents: 'none',
    },
    disabled: {
      opacity: 0.6,
      pointerEvents: 'none',
    },
  });

enum AppoitmentStatusEnum {
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed',
  Cancelled = 'cancelled',
  Arrived = 'confirmed-arrived',
  NoShow = 'cancelled-noshow',
}

interface FilterApptStatusSelectProps extends WithStyles<typeof styles> {
  staticData?: any;
  type: string;
}

const FilterApptStatusSelect: React.FC<FilterApptStatusSelectProps> = ({ classes, staticData, type }) => {
  const { updater, filters, readOnly } = useFiltersContext();

  const apptStatusUpdater = updater(type);
  const apptStatusFilter = filters[type];

  const handleSelectItem = (item: any) => {
    // Make sure clear the filters if the status reasons are selected
    if (
      [AppoitmentStatusEnum.Arrived, AppoitmentStatusEnum.NoShow].includes(item._id) &&
      !apptStatusFilter.includes(item._id)
    ) {
      return apptStatusUpdater([item._id]);
    }
    // regular flow if there only status selected or only status reason selected
    apptStatusUpdater(item._id);
  };

  const isAllSelected = filters[type].includes('all') && filters[type].length === 1;

  const isSelected = (id: string) =>
    (apptStatusFilter.includes('all') && !apptStatusFilter.includes(id)) ||
    (apptStatusFilter.includes('all') && apptStatusFilter.length === 1) ||
    (!apptStatusFilter.includes('all') && apptStatusFilter.includes(id));

  // We need to disable the status if any status reason is selected
  const shouldDisable = (itemId: string) =>
    [AppoitmentStatusEnum.Confirmed, AppoitmentStatusEnum.Cancelled, AppoitmentStatusEnum.Unconfirmed].includes(
      itemId as any,
    ) &&
    (isSelected(AppoitmentStatusEnum.Arrived) || isSelected(AppoitmentStatusEnum.NoShow));

  // We need to highlight related status when we select the respect status reasons
  const shouldHilightBasedOnStatusReason = (itemId: string) => {
    if (isSelected(AppoitmentStatusEnum.Arrived) && itemId === AppoitmentStatusEnum.Confirmed) return true;
    if (isSelected(AppoitmentStatusEnum.NoShow) && itemId === AppoitmentStatusEnum.Cancelled) return true;
    return false;
  };

  return (
    <div className={classes.contentWrapper}>
      <Grid
        className={classnames({
          [classes.readOnly]: readOnly,
        })}
        container
        spacing={8}
      >
        {staticData.map((item: any) => (
          <Grid item key={get(item, '_id', item.id)}>
            <Chip
              color="supportPowder"
              label={item.label}
              // WORKAROUND: MUI v3 has no disabled on Chip compnent
              className={isAllSelected || shouldDisable(item._id) ? classes.disabled : ''}
              onClick={() => handleSelectItem(item)}
              selected={isSelected(item._id) || shouldHilightBasedOnStatusReason(item._id)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(FilterApptStatusSelect);
